// LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="presentation" className="space-ptb">
            <div className="container-fluid w-special">
                <div className="row justify-content-between align-items-center">
                    <div className="col-12 col-lg-8">
                        <div className="mb-4 mb-lg-0">
                            <p className="sub-title">{t('homePage.presentation.subTitle')}</p>
                            <h2 className="mb-3 mb-xl-4">{t('homePage.presentation.title')}</h2>
                            <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para1') as string }}></p>
                            <p className="mb-4 mb-xl-5" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.para2') as string }}></p>
                            <Link to="/chi-siamo" className="btn btn-primary" title={t('homePage.presentation.btnTitle') as string}>
                                {t('homePage.presentation.btnText')}
                            </Link>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4">
                        <div className="text-center">
                            <img src="/assets/images/inHome/emanuela.webp" alt={t('homePage.presentation.image1Alt') as string} className="img-fluid my-img" />
                        </div>
                    </div>
                </div> 
            </div>
        </section>
    )
}
export default Presentation;